import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getProductTextResources = createGetTextResources({
    garantiekapitaalTeLaag: "Door de gekozen constructie wordt het beoogde doelvermogen niet gehaald."
});